import React from "react";
import PipelineDetails, {
    proposal,
    listing,
    underContract,
    closed,
} from "../PipelineDetails/PipelineDetails";
import {getData} from "../../requests/CRUD";
import {executeQuery} from "../../requests/executeQuery";
import {STRIVE_BUCKETS_DETAILS} from "../../consts/queries";
import { formatNames} from "../../utils";
import order from "../AgentPipelineDetails/order";
import {TEAM} from "../../consts/tables";
import moment from "moment";
import { GET_ALL_TEAMMEMBERS } from "../Graphql/Queries/TeamMemberQuery";
import { GET_STRIVE_BUCKETS_DETAILS, GET_TEAM_DATA } from "../Graphql/Queries/BucketsQuery";
import { GetOldResponse } from "../ResponseConversion/GetOldResponse";
import { fetchData } from "../Service/graphQlService";
import { GET_CONTACT_TEAM_BY_ARCIMEDES_ID, GET_CONTACT_TEAM_BY_ID } from "../Graphql/ContactsQueries/contactsQuery";

export default class BucketsDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {
                [proposal]: {
                    name: 'Proposals',
                    data: [],   
                    total: {},
                },
                [listing]: {
                    name: 'Listings - YTD',
                    data: [],
                    total: {},
                    message: ''
                },
                [underContract]: {
                    name: 'Neg/Under Contract',
                    data: [],
                    total: {},
                    message: ''
                },
                [closed]: {
                    name: 'Closed - YTD',
                    data: [],
                    total: {},
                    message: ''
                },
            },
            agentName: '',
            loading: true,
        };
        
    }

    buildTables(res) {
        const tables = {...this.state.tables};
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        tables[proposal] = BucketsDetails.buildTable(proposal, tables[proposal], res[0].data.striveBucketDetails.data, "", id);
        tables[listing] = BucketsDetails.buildTable(listing, tables[listing], res[1].data.striveBucketDetails.data, "", id);
        tables[underContract] = BucketsDetails.buildTable(underContract, tables[underContract], res[2].data.striveBucketDetails.data, "", id);
        tables[closed] = BucketsDetails.buildTable(closed, tables[closed], res[3].data.striveBucketDetails.data, "", id);
        this.setState({tables});
    }

    static createOptions({id, status = 'NOMATCH', proposals = 0, listings = 0, orderBy}) {
        const intID  = parseInt(id)
        return {
            param: {
                AGENT_ID: intID,
                STATUS: status,
                PROPOSALS: proposals,
                LISTINGS: listings,
            },
            order: order(orderBy),
        };
    }

    fetch(id) {
        const proposalOptions = BucketsDetails.createOptions({
            id: id,
            proposals: 1,
            orderBy: 'DATE_CREATED.asc'
        });
        const listingOptions = BucketsDetails.createOptions({
            id: id,
            listings: 1,
            orderBy: ['STATUS.asc', 'LISTING_DATE.asc']
        });
        const ucOptions = BucketsDetails.createOptions({
            id: id,
            status: underContract,
        });
        const closedOptions = BucketsDetails.createOptions({
            id: id,
            status: closed,
            orderBy: 'CLOSE_OF_ESCROW.asc'
        });
        
        // const requests = [
        //     executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: proposalOptions}),
        //     executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: listingOptions}),
        //     executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: ucOptions}),
        //     executeQuery({queryName: STRIVE_BUCKETS_DETAILS, options: closedOptions}),
        // ];
        
        let agentPhone = '';
        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
		const token = localStorage.getItem('authToken');
        const options = {
            column: [
                'ON_PHONES',
            ],
            filter: [{
                'text': id,
                'code': 'ARCIMEDES_ROW_ID',
                'type': 'exact',
            }],
        };
        Promise.all([
            // this.client.query({ query: GET_STRIVE_BUCKETS_DETAILS, variables:{proposals:proposalOptions.param.PROPOSALS,listings:listingOptions.param.LISTINGS,status:closedOptions.param.STATUS,agentId:id},
            // this.client.query({ query: GET_STRIVE_BUCKETS_DETAILS, variables:{proposals:proposalOptions.param.PROPOSALS,listings:proposalOptions.param.LISTINGS,status:proposalOptions.param.STATUS,agentId:proposalOptions.param.AGENT_ID},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            // this.client.query({ query: GET_STRIVE_BUCKETS_DETAILS, variables:{proposals:listingOptions.param.PROPOSALS,listings:listingOptions.param.LISTINGS,status:listingOptions.param.STATUS,agentId:listingOptions.param.AGENT_ID},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            //     this.client.query({ query: GET_STRIVE_BUCKETS_DETAILS, variables:{proposals:ucOptions.param.PROPOSALS,listings:ucOptions.param.LISTINGS,status:ucOptions.param.STATUS,agentId:ucOptions.param.AGENT_ID},
            //         fetchPolicy: "no-cache",
            //         context: {
            //           headers: {
            //             authorization: `Bearer ${token}`,
            //           },
            //         }}),
            // this.client.query({query:GET_STRIVE_BUCKETS_DETAILS, variables:{proposals:closedOptions.param.PROPOSALS,listings:closedOptions.param.LISTINGS,status:closedOptions.param.STATUS,agentId:closedOptions.param.AGENT_ID},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }}),
            //     this.client.query({query:GET_TEAM_DATA, variables:{arcimedesRowId:id},
            //         fetchPolicy: "no-cache",
            //         context: {
            //           headers: {
            //             authorization: `Bearer ${token}`,
            //           },
            //         }}),






                  fetchData( GET_STRIVE_BUCKETS_DETAILS, {proposals:proposalOptions.param.PROPOSALS,listings:proposalOptions.param.LISTINGS,status:proposalOptions.param.STATUS,agentId:proposalOptions.param.AGENT_ID}),
                  fetchData( GET_STRIVE_BUCKETS_DETAILS, {proposals:listingOptions.param.PROPOSALS,listings:listingOptions.param.LISTINGS,status:listingOptions.param.STATUS,agentId:listingOptions.param.AGENT_ID}),
                      fetchData( GET_STRIVE_BUCKETS_DETAILS, {proposals:ucOptions.param.PROPOSALS,listings:ucOptions.param.LISTINGS,status:ucOptions.param.STATUS,agentId:ucOptions.param.AGENT_ID}),
                  fetchData(GET_STRIVE_BUCKETS_DETAILS, {proposals:closedOptions.param.PROPOSALS,listings:closedOptions.param.LISTINGS,status:closedOptions.param.STATUS,agentId:closedOptions.param.AGENT_ID}),
                fetchData( GET_CONTACT_TEAM_BY_ARCIMEDES_ID,{arcimedes_row_id: Number(id)})
                    //   fetchData(GET_CONTACT_TEAM_BY_ID, {contactid:Number(id)}),we need to send arc_id so api we have for arc_id implementing same
                        // this.client.query({ query: x``
                        //     , variables:{proposals:proposalOptions.param.PROPOSALS,listings:listingOptions.param.LISTINGS,status:closedOptions.param.STATUS,agentId:id},
                        //     fetchPolicy: "no-cache",
                        //     context: {
                        //       headers: {
                        //         authorization: `Bearer ${token}`,
                        //       },
                        //     }}),
        ])
        // requests.push(getData({tableCode: TEAM, options}));
        // this.client.query({
        //     query: GET_STRIVE_BUCKETS_DETAILS, variables: { proposals: proposalOptions.param.PROPOSALS,listings:listingOptions.param.LISTINGS,status:ucOptions.param.STATUS,agentId:id }, fetchPolicy: "no-cache",
        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     },
        // })
        // .then(res => {
        //     if (res && res[0] && Array.isArray(res[0].data.striveBucketDetails.data) &&
        //         res[1] && Array.isArray(res[1].data.striveBucketDetails.data) &&
        //         res[2] && Array.isArray(res[2].data.striveBucketDetails.data) &&
        //         res[3] && Array.isArray(res[3].data.striveBucketDetails.data) &&
        //         res[4] && res[4].data.getTeamMember &&
        //         (!res[5] || res[5]  && res[5].data.getTeamMember)) {
        //         if (res[5]) {
        //             agentName = formatName(res[5].data.getTeamMember);
        //         }
        //         if (res[4]) {
        //             agentPhone = res[4].data.getTeamMember.on_phones;
        //             if (agentPhone) {
        //                 this.calculateDateRange(agentPhone);
        //             }
        //         }
        //         this.setState({agentName}, () => this.buildTables(res));
        //     }
        //     this.setState({loading: false});
        // })
    .then(res => {
        if (res && res[0] && Array.isArray(res[0].data.striveBucketDetails.data) &&
            res[1] && Array.isArray(res[1].data.striveBucketDetails.data) &&
            res[2] && Array.isArray(res[2].data.striveBucketDetails.data) &&
            res[3] && Array.isArray(res[3].data.striveBucketDetails.data) &&
            res[4] && res[4].data.getContactTeamByArcId.contact &&
            (!res[5] || res[5]  && res[5].data.getContactTeamByArcId.contact)) {
            if (res[5]) {
                agentName = formatNames(res[5].data.getContactTeamByArcId.contact);
            }
            if (res[4] && res[4].data.getContactTeamByArcId.contact) {
                if(!agentName){
                    agentName = formatNames(res[4].data.getContactTeamByArcId.contact);
                }
                agentPhone = res[4].data.getContactTeamByArcId.contact.on_phones;
              
                if (agentPhone) {
                    this.calculateDateRange(agentPhone);
                }
            }
            this.setState({agentName}, () => this.buildTables(res));
        }
        this.setState({loading: false});
    })
        if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            // this.client.query({query:GET_TEAM_DATA, variables:{arcimedesRowId:id},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     }})

                fetchData( GET_CONTACT_TEAM_BY_ARCIMEDES_ID,{arcimedes_row_id: Number(id)})
                // fetchData(GET_CONTACT_TEAM_BY_ID, {contactid:Number(id)}) we need to send arc_id so api we have for arc_id implementing same
            // requests.push(getData({tableCode: TEAM, options}));
        }


    }

    calculateDateRange(date) {
        // const givenDate = moment(date, 'YYYY-MM-DD'); due to formate change on "on_phone" in team member
        const givenDate = moment(date,'MM-DD-YYYY')
        const today = moment();
        const diffInYrs = today.diff(givenDate, 'years', true);
        if (diffInYrs <= 1.5) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[listing].goalValue =3,
            this.state.tables[underContract].goalValue = 2
            this.state.tables[closed].goalValue = 4
        } else if (diffInYrs > 1.5 && diffInYrs <= 3) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[listing].goalValue =6,
            this.state.tables[underContract].goalValue = 4
            this.state.tables[closed].goalValue = 8
        } else if (diffInYrs > 3) {
            this.state.tables[proposal].goalValue = 4
            this.state.tables[listing].goalValue =10,
            this.state.tables[underContract].goalValue = 5
            this.state.tables[closed].goalValue = 12
        }
        this.setState({tables: {...this.state.tables}});
    }

    componentDidMount() {
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        if (id) {
            const intID  = parseInt(id)
            this.fetch(intID);
            return;
        }
        if (this.client) {
			this.fetch(this.props.location.query);
		}
        this.setState({loading: false});
    }
}